<div class="full-size p-2" >

  <app-cup-list></app-cup-list>
  <p>last update: {{timestamp | date}}</p>

</div>
